export default class AbstractColumn {
    label = null
    field = null
    type = null
    htmlType = 'input'
    isVisible = true
    isInsertable = true
    isEditable = true
    onEditDisabled = false
    onInsertDisabled = false
    size = 'small'
    htmlClass = ''
    width = null
    html = false
    isTitle = false
    isId = false
    exportable = null

    init (field) {
      this.field = field
      this.label = 'column.' + this.field
      return this
    }

    withExportable (exportable) {
      this.exportable = exportable
      return this
    }

    withIsId (isId) {
      this.isId = isId
      return this
    }

    withIsTitle (isTitle) {
      this.isTitle = isTitle
      return this
    }

    withLabel (label) {
      this.label = label
      return this
    }

    withField (field) {
      this.field = field
      return this
    }

    withType (type) {
      this.type = type
      return this
    }

    withHtmlType (htmlType) {
      this.htmlType = htmlType
      return this
    }

    withIsVisible (isVisible) {
      this.isVisible = isVisible
      return this
    }

    withIsInsertable (isInsertable) {
      this.isInsertable = isInsertable
      return this
    }

    withIsEditable (isEditable) {
      this.isEditable = isEditable
      return this
    }

    withOnEditDisabled (onEditDisabled) {
      this.onEditDisabled = onEditDisabled
      return this
    }

    withOnInsertDisabled (onInsertDisabled) {
      this.onInsertDisabled = onInsertDisabled
      return this
    }

    withSize (size) {
      this.size = size
      return this
    }

    withHtmlClass (htmlClass) {
      this.htmlClass = htmlClass
      return this
    }

    withWidth (width) {
      this.width = width
      return this
    }

    withHtml (html) {
      this.html = html
      return this
    }
}
